import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Card, CardBody } from "reactstrap"

import { Link } from "react-router-dom"

import servicesIcon1 from "../../assets/images/services-icon/01.png"
import servicesIcon2 from "../../assets/images/services-icon/02.png"
import servicesIcon3 from "../../assets/images/services-icon/03.png"
import servicesIcon4 from "../../assets/images/services-icon/04.png"

import "./dashboard.css"

import Applications from "./applications"
import Application from "services/PlasticsApplication.service"

const Dashboard = () => {
  const [menu, setMenu] = useState(false)
  const [mounted, setmounted] = useState(false)
  const [applications, setapplications] = useState({data: []})
  const [statistics, setstatistics] = useState()

  const user = JSON.parse(localStorage.getItem("authUser"))

  const appService = new Application(user)


  useEffect(() => {
    appService.getAllApplications().then(response => {
      // console.log("resp ", response)
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
    appService.getStatistics().then(response => {
      if (response.status) {
        setstatistics(response.data)
      }
    })
  }, [])
  const toggle = () => {
    setMenu(!menu)
  }

  // fetch applications next/prev page
  const fetchApplicationsPage = page => {
    appService.getApplicationsPagination(page).then(response => {
      // console.log(response)
      if (response.status) {
        setapplications(response.data)
      }
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Dashboard</h6>
                {/* <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to your Dashboard
                  </li>
                </ol> */}
              </Col>
            </Row>
            
            <Row>
              <Col xl={3} md={6}>
                <Card className="mini-stat iconComponent text-white">
                  <CardBody>
                    <div className="mb-4">
                      <div className="float-start mini-stat-img me-4">
                        <img src={servicesIcon1} alt="" />
                      </div>
                      <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                        SUBMITTED
                      </h5>
                      <h4 className="fw-medium font-size-24">
                        {statistics && statistics.all_applications}{" "}
                        <i className="mdi mdi-arrow-up text-success ms-2"></i>
                      </h4>
                      <div className="mini-stat-label bg-warning">
                        <p className="mb-0"> | </p>
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className="float-end">
                        <Link to="#" className="text-white-50">
                          <i className="mdi mdi-arrow-right h5"></i>
                        </Link>
                      </div>
                      <p className="text-white-50 mb-0 mt-1">
                        Since last month
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={3} md={6}>
                <Card className="mini-stat iconComponent text-white">
                  <CardBody>
                    <div className="mb-4">
                      <div className="float-start mini-stat-img me-4">
                        <img src={servicesIcon2} alt="" />
                      </div>
                      <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                        PROCESSING
                      </h5>
                      <h4 className="fw-medium font-size-24">
                        {statistics && statistics.processing}{" "}
                        <i className="mdi mdi-arrow-down text-danger ms-2"></i>
                      </h4>
                      <div className="mini-stat-label bg-info">
                        <p className="mb-0"> | </p>
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className="float-end">
                        <Link to="#" className="text-white-50">
                          <i className="mdi mdi-arrow-right h5"></i>
                        </Link>
                      </div>

                      <p className="text-white-50 mb-0 mt-1">
                        Since last month
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={3} md={6}>
                <Card className="mini-stat iconComponent text-white">
                  <CardBody>
                    <div className="mb-4">
                      <div className="float-start mini-stat-img me-4">
                        <img src={servicesIcon3} alt="" />
                      </div>
                      <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                        APPROVED
                      </h5>
                      <h4 className="fw-medium font-size-24">
                        {statistics && statistics.approved}{" "}
                        <i className="mdi mdi-arrow-up text-success ms-2"></i>
                      </h4>
                      <div className="mini-stat-label bg-success">
                        <p className="mb-0"> | </p>
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className="float-end">
                        <Link to="#" className="text-white-50">
                          <i className="mdi mdi-arrow-right h5"></i>
                        </Link>
                      </div>

                      <p className="text-white-50 mb-0 mt-1">
                        Since last month
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={3} md={6}>
                <Card className="mini-stat iconComponent text-white">
                  <CardBody>
                    <div className="mb-4">
                      <div className="float-start mini-stat-img me-4">
                        <img src={servicesIcon4} alt="" />
                      </div>
                      <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                        REJECTED
                      </h5>
                      <h4 className="fw-medium font-size-24">
                        {statistics && statistics.rejected}{" "}
                        <i className="mdi mdi-arrow-up text-success ms-2"></i>
                      </h4>
                      <div className="mini-stat-label bg-danger">
                        <p className="mb-0"> | </p>
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className="float-end">
                        <Link to="#" className="text-white-50">
                          <i className="mdi mdi-arrow-right h5"></i>
                        </Link>
                      </div>
                      <p className="text-white-50 mb-0 mt-1">
                        Since last month
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <h4>Custom Service Dashboards</h4>
              <h5><a href="env-audit-menu">Environmental Services</a></h5>
            </Row>

              <Row>
                <Applications
                  data={applications}
                  paginate={fetchApplicationsPage}
                />
              </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
